import { useEffect, useState } from 'react';
import { Box, Image, type BoxProps } from '@chakra-ui/react';

const BEELDEN = [1, 2, 3, 4].map((n) => `/icons/animated-logo/${n}.svg`);

/** Elke 125 ms het volgende beeld, zoals in het origineel. */
const SNELHEID = 125;

/**
 * Het bewegende AME-logo, het wachtteken van het spel ("Wacht nog even tot iedereen zijn
 * taken gespeeld heeft."). Alle props gaan naar de buitenste `Box`, zoals in het origineel.
 *
 * Het origineel zocht de beelden op met een DOM-query op een willekeurig id en zette hun
 * `display` met de hand; hier doet React dat met een teller. Het logo is decoratief: de
 * tekst ernaast zegt waarop gewacht wordt.
 */
export function AnimatedLogo(props: BoxProps) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setIndex((i) => (i + 1) % BEELDEN.length), SNELHEID);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box aria-hidden {...props}>
      <Box position="relative">
        {BEELDEN.map((src, i) => (
          <Image
            key={src}
            src={src}
            alt=""
            position="absolute"
            display={i === index ? 'initial' : 'none'}
          />
        ))}
      </Box>
    </Box>
  );
}
